// Auth API
export const AUTH = {
  LOGIN: "/auth/login",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
  REFRESH_TOKEN: "/auth/refresh-token",
  ME: "/auth/me",
};

// Builder API
export const BUILDER = {
  LIST: "/builders",
  CREATE: "/builders",
  GET: (id) => `/builders/${id}`,
  UPDATE: (id) => `/builders/${id}`,
  DELETE: (id) => `/builders/${id}`,
  STATUS: (id) => `/builders/${id}/status`,
  ASSIGN_PLAN: (id) => `/builders/${id}/assign-plan`,
};

// User Management API
export const USER = {
  LIST: "/users",
  CREATE: "/users",
  GET: (id) => `/users/${id}`,
  UPDATE: (id) => `/users/${id}`,
  DELETE: (id) => `/users/${id}`,
  STATUS: (id) => `/users/${id}/status`,
  ROLES: (id) => `/users/${id}/roles`,
};

export const ROLE = {
  LIST: "/roles",
  CREATE: "/roles",
  GET: (id) => `/roles/${id}`,
  UPDATE: (id) => `/roles/${id}`,
  DELETE: (id) => `/roles/${id}`,
  PERMISSIONS: (id) => `/roles/${id}/permissions`,
};

export const PERMISSION = {
  LIST: "/permissions",
};

// Plan API
export const PLAN = {
  LIST: "/plans",
};

// Project API
export const PROJECT = {
  LIST: "/projects",
  CREATE: "/projects",
  GET: (id) => `/projects/${id}`,
  UPDATE: (id) => `/projects/${id}`,
  DELETE: (id) => `/projects/${id}`,
};

